import React, { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';

import './novoSistema.css';

function NovoSistema(props) {

    const history = useHistory();

    const location = useLocation();
    const { id } = location.state || {};

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [codSis, setCodSis] = useState('');
    const [nomSis, setNomSis] = useState('');
    const [desSis, setDesSis] = useState('');
    const [setSis, setSetSis] = useState('');
    const [sitSis, setSitSis] = useState('');

    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');

    const [placeId, setPlaceId] = useState("Digite sequência do sistema para edição ou deixe em branco para adicionar");

    const verificarCampos = async () => {

        if (nomSis.trim() === '') {
            setMensagem("Atenção deve ser inserido o nome do sistema!")
            return;
        }

        if (desSis.trim() === '') {
            setMensagem("Atenção deve ser inserida uma descrição válida!");
            return;
        }

        if (setSis.trim() === '') {
            setMensagem("Atenção deve ser inserido o setor responsável!");
            return;
        }

        if (sitSis.trim() === '') {
            setMensagem("Atenção deve ser inserida situação do sistema!");
            return;
        }

        setMensagem("");
    };

    const buscandoSistema = async (codSis) => {

        verificandoToken();

        const token = localStorage.getItem('token');

        if (codSis) {
            try {
                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas/espec", {
                    headers: {
                        Authorization: `${token}`
                    },
                    params: {
                        codSis: codSis
                    }
                });

                if (response.data.length > 0) {

                    setUpdIns("U");

                    setCodSis(codSis);
                    setNomSis(response.data[0].nomsis);
                    setDesSis(response.data[0].dessis);
                    setSetSis(response.data[0].setsis);
                    setSitSis(response.data[0].sitsis);
                } else {

                    setUpdIns("I");

                    setCodSis("");
                    setNomSis("");
                    setDesSis("");
                    setSetSis("");
                    setSitSis("");
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        }
    };

    useEffect(() => {

        verificar();

        if (id) {
            setPlaceId(id);
            setCodSis(id);
            buscandoSistema(id);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const inserindoSistema = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas",
                    {nomSis,desSis,setSis,sitSis},
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });
            } else {

                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas",
                    {codSis,nomSis,desSis,setSis,sitSis},
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

            }
            setMensagem('');
            setSucesso('S');
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo">
            <div className="col-4">
                <h1>{updIns === 'U' ? "Alterar" : "Cadastrar"} Sistema</h1>
            </div>
            <form>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Sequência Sistema</label>
                    <input type="email" onChange={(e) => buscandoSistema(e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={placeId} />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Nome</label>
                    <input type="email" onChange={(e) => setNomSis(e.target.value)} value={nomSis} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nome Sistema" />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Descrição</label>
                    <input type="email" onChange={(e) => setDesSis(e.target.value)} value={desSis} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Descrição Sistema " />
                </div>
                <div className="form-group mb-1">
                    <label for="exampleInputEmail1">Setor Responsável</label>
                    <input type="email" onChange={(e) => setSetSis(e.target.value)} value={setSis} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Setor Responsável" />
                </div>

                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label for="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={sitSis} onChange={(e) => { setSitSis(e.target.value) }}>
                            <option selected>Escolher...</option>
                            <option value={"A"}>Ativo</option>
                            <option value={"I"}>Inativo</option>
                        </select>
                    </div>
                </div>

                <button onClick={inserindoSistema} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/home' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoSistema;